const listItemText = {
  styleOverrides: {
    root: {
      paddingTop: "0!important",
      marginTop: 0,
      marginBottom: 0,
    },
  },
};

export default listItemText;
